export default __webpack_public_path__ + "static/shutdown-banner-web-42db488380459e1c851df09bb5a5f49d.png";